import { FC, SVGProps } from "react";

export const RayLineIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 16,
  height = 16,
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 171 171.1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        ...style,
      }}
      {...props}
    >
      <path
        d="M53.3 128.4c-3.9-3.9-7.3-7.5-11-11.2C81.2 78.4 120.4 39.2 159.7 0L171 11.3c-39.3 39-78.4 78-117.7 117.1zm-30.4-2.2c12.5.2 22.3 10.5 22 23-.3 12.2-10.5 22.1-22.7 21.9C9.8 171-.2 160.7 0 148.3c.2-12.4 10.5-22.4 22.9-22.1z"
        fill={fill}
      />
    </svg>
  );
};
